/* import __COLOCATED_TEMPLATE__ from './team-availability.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();